// hooks/use-auth.js — AUTH + USER RECORD + NAMING
// ═══════════════════════════════════════════════════════════
// Extracted from pages/index.js to keep shell lean.
// Owns: session, authLoading, userRecord, naming flow.
// ═══════════════════════════════════════════════════════════
import { useState, useEffect, useCallback } from 'react';

export function useAuth(supabase) {
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [userRecord, setUserRecord] = useState(null);

  // Auth listener
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s);
      setAuthLoading(false);
      if (s?.user?.id) {
        fetch('/api/auth-notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: s.user.id,
            ip: null,
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
          }),
        }).catch(() => {});
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  // Load user record
  const loadUserRecord = useCallback(async () => {
    if (!session) return;
    try {
      const { data: user } = await supabase
        .from('users')
        .select('*')
        .eq('id', session.user.id)
        .single();
      if (!user) {
        const referralCode = Math.random().toString(36).substring(2, 8).toUpperCase();
        const meta = session.user.user_metadata || {};
        const firstName = meta.full_name?.split(' ')[0] || meta.name?.split(' ')[0] || '';
        const lastName = meta.full_name?.split(' ').slice(1).join(' ') || '';
        const { data: newUser } = await supabase.from('users')
          .insert({
            id: session.user.id,
            email: session.user.email,
            first_name: firstName,
            last_name: lastName,
            ai_name: null,
            username: null,
            portrait_v2: {},
            unclassified_facts: [],
            session_count: 0,
            ideas: [],
            referral_code: referralCode,
            onboarding_complete: false
          })
          .select().single();
        setUserRecord(newUser);
        return;
      }
      setUserRecord(user);
    } catch (e) { console.error('loadUserRecord:', e); }
  }, [session]);

  useEffect(() => {
    if (session) loadUserRecord();
  }, [session, loadUserRecord]);

  return {
    session, authLoading,
    userRecord, setUserRecord,
  };
}